// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".i70FJZVFTFdXmA {\n  font-size: 12px;\n  margin: 0;\n  padding: 4px 8px;\n}\n.i70FJZVFTFdXmA ._10gQ-LTtxgGGiV {\n  transition: transform ease-in-out;\n  transition-duration: 500ms;\n  transform: rotate(0);\n  display: inline-flex;\n  padding-left: 2px;\n}\n.i70FJZVFTFdXmA.olRDL0FA-qoKzc ._10gQ-LTtxgGGiV {\n  transform: rotate(180deg);\n}\n.i70FJZVFTFdXmA:active,\n.i70FJZVFTFdXmA:focus {\n  background-color: transparent;\n  color: #6B778C;\n}\n.i70FJZVFTFdXmA:hover {\n  color: #172b4d;\n  cursor: pointer;\n  background: none;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"archiveButton": "i70FJZVFTFdXmA",
	"icon": "_10gQ-LTtxgGGiV",
	"active": "olRDL0FA-qoKzc"
};
export default ___CSS_LOADER_EXPORT___;
